import type { TutorReply } from './tutorChat';
import type { TutorUpload } from './tutorImages';
import { getKidSub, useAuthStore } from '@/auth/authStore';
export interface WorkingTutorTurn {
  id: string;
  message: string;
  version: number;
  reply: TutorReply;
  stars: number;
  uploads: TutorUpload[];
  omittedPhotos?: number;
  sourceFingerprint?: string;
}
const entries = new Map<string, { owner: string; at: number; turns: WorkingTutorTurn[] }>();
const TTL = 60 * 60 * 1000;
let actor = getKidSub(),
  actorGeneration = 0;
useAuthStore.subscribe?.(() => {
  const next = getKidSub();
  if (next !== actor) {
    actor = next;
    actorGeneration += 1;
    entries.clear();
  }
});
export const workingTutorActorGeneration = () => actorGeneration;
export function forgetWorkingTutorReturn(owner: string | null, scope: string) {
  entries.delete(`${owner}:${scope}`);
}
/** Same-document navigation only. No private conversation is placed in URLs or browser storage. */
export function readWorkingTutorReturn(owner: string | null, scope: string) {
  for (const [key, entry] of entries)
    if (entry.owner !== owner || Date.now() - entry.at >= TTL) entries.delete(key);
  return owner ? (entries.get(`${owner}:${scope}`)?.turns ?? []) : [];
}
export function keepWorkingTutorReturn(
  owner: string | null,
  scope: string,
  turns: WorkingTutorTurn[],
) {
  if (!owner || !scope) return;
  readWorkingTutorReturn(owner, scope);
  const key = `${owner}:${scope}`;
  entries.delete(key);
  if (entries.size >= 10) entries.delete(entries.keys().next().value!);
  const retained = turns.slice(-6).map((turn) => ({
    ...turn,
    omittedPhotos: turn.omittedPhotos ?? turn.uploads.length,
    uploads: [],
  }));
  if (JSON.stringify(retained).length > 200000) return;
  entries.set(key, { owner, at: Date.now(), turns: retained });
}
